var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showEpComp,
          expression: "showEpComp",
        },
      ],
      staticClass: "new-mask",
      on: { click: _vm.maskClick },
    },
    [
      _c("div", { staticClass: "plot-pop" }, [
        _c("div", { staticClass: "plot-pop-tit" }, [
          _c("div", { staticClass: "tit reverse" }, [
            _vm._v("\n        选集\n      "),
          ]),
          _vm._v(" "),
          _vm.plotUpdatingEp > 0
            ? _c("div", { staticClass: "plot-nums" }, [
                _vm._v("\n        " + _vm._s(_vm.epText) + "\n      "),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.showNumStyle
          ? _c(
              "ul",
              { staticClass: "plot-pop-con2" },
              [
                _vm._l(_vm.numList, function (value, i) {
                  return [
                    i > 0
                      ? _c("li", { key: i, class: { dis: !value } }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: value
                                  ? _vm.getUrl(i)
                                  : "javascript:void(0);",
                                uigs: "episode_num_click_" + i,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(i) + "\n          "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                }),
              ],
              2
            )
          : _c(
              "ul",
              { staticClass: "plot-pop-con1" },
              _vm._l(_vm.titleList, function (item, key, index) {
                return _c(
                  "li",
                  { key: index },
                  [
                    index + 1 <= _vm.plotUpdatingEp
                      ? [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.getUrl(key),
                                uigs: "episode_title_click_" + key,
                              },
                            },
                            [
                              _vm._v(
                                "\n            " + _vm._s(item) + "\n          "
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }